import { render, staticRenderFns } from "./VideoGeneration.vue?vue&type=template&id=4e37880a&scoped=true&"
import script from "./VideoGeneration.vue?vue&type=script&lang=js&"
export * from "./VideoGeneration.vue?vue&type=script&lang=js&"
import style0 from "./VideoGeneration.vue?vue&type=style&index=0&id=4e37880a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e37880a",
  null
  
)

export default component.exports